<div class="p-2">
  @if (!qrCodeList?.length) {
    <div>
      <div
        class="d-flex flex-column flex-md-row-reverse gap-3 align-items-center"
      >
        <div class="flex-md-grow-1 mb-2 mb-md-0 p-2 p-lg-4">
          <div class="fw-semibold">
            Use a mobile device to scan and add QR Codes.
          </div>
        </div>
        <div class="d-flex flex-column gap-2">
          <div>
            <button
              id="generateQRCodes"
              class="btn btn-primary btn-lg w-100"
              (click)="openTemplate(qrGenerateTemplateRef)"
            >
              Get New QR Codes
            </button>
          </div>
          @if (qrCpTotalCount > 0) {
            <div>
              <button
                id="generateOldQRCodes"
                class="btn btn-secondary btn-lg w-100"
                (click)="openTemplate(existingQrGenerateTemplateRef)"
              >
                Reprint QR Codes
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (qrCodeList?.length) {
    <div>
      <div class="row mt-2">
        <div class="col-lg-4">
          <div class="alert alert-primary" role="alert">
            {{ qrCodeList?.length }} QR Codes Ready
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-lg-4 text-lg-start text-center">
          <button
            class="btn btn-outline-primary btn-lg btn-block"
            (click)="downloadQRCodes()"
          >
            Get QR Codes
          </button>
        </div>
      </div>
    </div>
  }
</div>

<ng-template #qrGenerateTemplateRef let-qrGenerateTemplateRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Generate QR Codes
      <span class="float-end" (click)="qrGenerateTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="p-1">
      <div>
        <ng-template *ngTemplateOutlet="qrSizeSelectionTemplate"></ng-template>

        <div class="form-floating mb-3">
          <select
            class="form-select"
            [(ngModel)]="qrDefaultCount"
            placeholder="Quantity Needed"
          >
            @for (no of qrCountOptions; track no) {
              <option [value]="no">
                {{ no }}
              </option>
            }
          </select>
          <label for="">Quantity Needed</label>
        </div>
        <div class="row row-cols-2">
          <div class="col">
            <button
              type="button"
              class="btn btn-dark btn-lg w-100"
              (click)="qrGenerateTemplateRef.close()"
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              class="btn btn-primary btn-lg w-100"
              (click)="generateNQRcodes(); qrGenerateTemplateRef.close()"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #qrSizeSelectionTemplate>
  <div class="fw-semibold fs-6 mb-2">Select QR Code Size</div>
  <div class="btn-group w-100 btn-group-lg mb-4" role="group">
    <button
      type="button"
      class="btn text-lowercase"
      (click)="qrSizeChanged(35)"
      [ngClass]="35 == selectedQrSize ? 'btn-primary' : 'btn-outline-primary'"
    >
      35 x 35mm
    </button>
    <button
      type="button"
      class="btn text-lowercase"
      (click)="qrSizeChanged(12)"
      [ngClass]="12 == selectedQrSize ? 'btn-primary' : 'btn-outline-primary'"
    >
      63.5 x 72mm
    </button>
  </div>

  <div class="mb-4">
    <p>
      Intended for use with

      <a
        [href]="
          selectedQrSize === 35
            ? 'https://www.averyproducts.com.au/blank-labels/square-35x35mm'
            : 'https://www.averyproducts.com.au/blank-labels/rectangle-72x63mm'
        "
        target="_blank"
        rel="noopener"
        class="fw-semibold"
        >{{ selectedQrSize === 35 ? "35 x 35mm" : "63.5 x 72mm" }}</a
      >
      blank labels.
    </p>

    @if (selectedQrSize != 35) {
      <div>
        <p>Large QR codes, better suited for scans from further away.</p>
      </div>
    }
  </div>

  <div class="mb-4 d-flex align-items-center px-3">
    <input
      #fileInput
      id="fileInput"
      class="d-none"
      type="file"
      accept="image/*"
      (change)="handleFileInput($event.target)"
    />
    @if (companyLogoPresent) {
      <div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="includeLogo == 1"
            (change)="includeLogo = includeLogo == 1 ? 0 : 1"
            id="includeLogo"
          />
          <label
            class="form-check-label disable-text-select"
            for="includeLogo"
            role="button"
            [ngClass]="includeLogo ? 'fw-semibold' : ''"
          >
            Show Company Logo on QR Codes
          </label>
        </div>
      </div>
    } @else {
      <div class="d-flex justify-content-center w-100">
        <span
          (click)="openCamPopup()"
          class="border py-2 px-3 rounded fw-semibold border-2 hover text-dark bg-white text-center"
          role="button"
        >
          Upload Company Logo and Show on QR Codes
        </span>
      </div>
    }
  </div>
</ng-template>

<ng-template
  #existingQrGenerateTemplateRef
  let-existingQrGenerateTemplateRef="dialogRef"
  let-data
>
  <div class="card dialog-box">
    <div class="card-header">
      @if (data?.currentStep == 2) {
        Select Checkpoints
        <span class="fw-semibold text-primary"
          >[{{ 35 == selectedQrSize ? "35 x 35mm" : "63.5 x 72mm" }}]</span
        >
      }

      <span class="float-end" (click)="existingQrGenerateTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      @if (data?.currentStep == 1) {
        <ng-template *ngTemplateOutlet="qrSizeSelectionTemplate"></ng-template>
        <div class="row row-cols-2 my-3">
          <div class="col">
            <button
              type="button"
              class="btn btn-dark btn-lg w-100"
              (click)="
                selectedQrCheckpoints = [];
                qrCPList = [];
                existingQrGenerateTemplateRef.close()
              "
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              class="btn btn-primary btn-lg w-100"
              (click)="data.currentStep = 2"
            >
              Next
            </button>
          </div>
        </div>
      }
      @if (data?.currentStep == 2) {
        <div class="row row-cols-2 mb-3">
          <div class="col">
            <button
              type="button"
              class="btn btn-dark btn-lg w-100"
              (click)="data.currentStep = 1"
            >
              Back
            </button>
          </div>
          <div class="col">
            <button
              class="btn btn-success btn-lg w-100"
              [disabled]="!selectedQrCheckpoints?.length"
              (click)="generateExistingQRCodes()"
            >
              Next
            </button>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-between my-3">
          <div class="d-flex text-primary align-items-center">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="selectedQrCheckpoints?.length === qrCPList?.length"
              (change)="selectAllCheckpoints($event)"
              id="selectAllBox"
            />
            <label for="selectAllBox" class="mt-1"
              >Select All [{{ qrCPList?.length }}]</label
            >
          </div>
          @if (selectedQrCheckpoints?.length) {
            <div>
              <dt>
                Total Checkpoints Selected:
                <span class="fw-semibold fs-6">{{
                  selectedQrCheckpoints?.length
                }}</span>
              </dt>
            </div>
          }
        </div>
        <div class="input-group my-2">
          @if (qrCpTotalCount > 3) {
            <div class="form-floating">
              <input
                class="form-control"
                type="text"
                placeholder="Filter Checkpoints"
                (input)="filterQRCheckpoints()"
                [(ngModel)]="qrCpFilterValue"
              />
              <label>Filter Checkpoints</label>
            </div>
          }
          @if (qrCpFilterValue) {
            <span
              class="input-group-text"
              (click)="filterQRCheckpoints(); qrCpFilterValue = ''"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
        <div class="overflow-45vh">
          <table class="table table-responsive">
            <tbody>
              @for (checkpoint of qrCPList; track checkpoint) {
                <tr
                  (click)="addRemoveCheckpoint(checkpoint)"
                  class="cursor-pointer"
                >
                  <td>
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [checked]="checkpoint?.selected"
                    />
                  </td>
                  <td>
                    {{ checkpoint?.name }}
                    <div>
                      @if (checkpoint?.site_name) {
                        {{ checkpoint?.site_name }} [ {{ checkpoint?.company }}]
                      } @else {
                        {{ checkpoint?.company }}
                      }
                    </div>
                    <div class="small-font text-secondary">
                      {{ checkpoint?.address?.full_address }}
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (qrCpCursor) {
          <div class="my-3 text-center">
            <button
              type="button"
              class="btn btn-secondary btn-md"
              (click)="onLoadMoreCheckpoints()"
            >
              Load More
            </button>
          </div>
        }
      }
    </div>
  </div>
</ng-template>
